// app环境下
export enum WEBVIEW_PLATFORM {
  // 安卓
  ANDROID = 1,
  // ios
  IOS = 2,
  // 不处于 webview
  NONE = 3
}

export enum USER_AGENT {
  ANDROID = "svmMYXlPEKw/CCpA==",
  IOS = "CCpA==/svmMYXlPEKw"
}

// 浏览器环境
export enum BROWSER_PLATFORM {
  DEFAULT = 1,
  FACEBOOK = 2,
  TELEGRAM = 3,
  TWITTER = 4,
  SAFARI = 5
}

// 浏览器环境
export enum BROWSER_PLATFORMSRING {
  EMAILl = "email",
  FACEBOOK = "facebook",
  FACEBOOKAUTH = "facebook_auth",
  TELEGRAM = "telegram",
  TELEGRAM_WIDGET = "telegram_widgets",
  TWITTER = "twitter",
  SAFARI = "apple",
  GOOGLE = "google"
}
